import axios from 'axios';
import { Toast, Notify } from 'vant';
// import { saveAs } from "file-saver";

const instance = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: "/idata"
})

instance.interceptors.request.use(config => {
    return config;
});

instance.interceptors.response.use(
    res => {
        Toast.clear();
        if (res.data.code == 200) {
            return res.data;
        } else {
            let messageType = 'danger';
            let lastTwoCode = res.data.code % 100;
            if (lastTwoCode >= 31 && lastTwoCode < 60) {
                messageType = 'warning';
            } else if (lastTwoCode >= 61 && lastTwoCode < 90) {
                messageType = 'primary';
            }

            let msg = res.data.code + ": " + res.data.message;
            Notify({ type: messageType, duration: 10000, message: msg });
            return Promise.reject(new Error(msg));
        }
    },
    error => {
        Toast.clear();
        let { message } = error;
        Notify({ type: 'danger', duration: 10000, message: message });
        return Promise.reject(error);
    }
)

instance.showLoading = function (msg) {
    if (!msg) {
        msg = "加载中..";
    }
    Toast.loading({
        duration: 0,
        message: msg,
        forbidClick: true,
    });
    return this;
}

export default instance;

// function tansParams(params) {
//     let result = ''
//     for (const propName of Object.keys(params)) {
//         const value = params[propName];
//         var part = encodeURIComponent(propName) + "=";
//         if (value !== null && value !== "" && typeof (value) !== "undefined") {
//             if (typeof value === 'object') {
//                 for (const key of Object.keys(value)) {
//                     if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
//                         let params = propName + '[' + key + ']';
//                         var subPart = encodeURIComponent(params) + "=";
//                         result += subPart + encodeURIComponent(value[key]) + "&";
//                     }
//                 }
//             } else {
//                 result += part + encodeURIComponent(value) + "&";
//             }
//         }
//     }
//     return result
// }

// export function download(url, params, fileName) {
//     console.log("downloadFile, url: " + url + ", fileName: " + fileName);
//     axios
//         .get(url, params, {
//             transformRequest: [(params) => { return tansParams(params) }],
//             headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//             responseType: 'blob'
//         })
//         .then(async (data) => {
//             console.log("downloadFile success");
//             const blob = new Blob([data]);
//             saveAs(blob, fileName);
//         })
//         .catch((res) => {
//             console.error("downloadFile fail", res);
//             this.$notify({
//                 type: "danger",
//                 duration: 3000,
//                 message: "文件下载失败",
//             });
//         });
// }

// export function download(url, fileName) {
//     console.log("downloadFile, url: " + url + ", fileName: " + fileName);
//     axios
//         .get(url, { responseType: "blob" })
//         .then(res => {
//             // get成功后，res后端返回的数据
//             console.log(res)
//             let content = new Blob([res.data], {});
//             //兼容性处理
//             let urlObject = window.URL || window.webkitURL || window;
//             //获取下载地址href的指向
//             let url = urlObject.createObjectURL(content);
//             //创建a元素
//             let a = document.createElement('a');
//             //给a元素的href添加下载后端传递过来的文件
//             a.href = url;
//             //给下载的文件添加名字
//             a.download = fileName;
//             //给生成的a元素绑定单击事件
//             a.click();
//             // 静态方法用来释放一个之前已经存在的、通过调用 URL.createObjectURL() 创建的 URL 对象。当你结束使用某个 URL 对象之后，应该通过调用这个方法来让浏览器知道不用在内存中继续保留对这个文件的引用了。
//             urlObject.revokeObjectURL(url)
//         })
//         .catch((res) => {
//             console.error("downloadFile fail", res);
//             Notify({
//                 type: "danger",
//                 duration: 3000,
//                 message: "文件下载失败",
//             });
//         });
// }